import { post, put, get } from "../fetch.v2"

const route = "/authentications"

const AuthenticationApi = {
  login: (email: string, password: string) =>
    post(`${route}/login`, { email, password })
}

export default AuthenticationApi
